// extracted by mini-css-extract-plugin
export default {"chatContainer":"Chat_chatContainer__sWEx1","messageContainer":"Chat_messageContainer__AtuI6","emptyState":"Chat_emptyState__JV0Dm","errorButton":"Chat_errorButton__CtIwe"};